const regExps = {
  /* L - letters
     N - Numbers
     S - Special characters
  */
  commonValidations: {
    LNS: /^([0-9a-zA-Z!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~ \n])*$/,
    LN: /^([0-9a-zA-Z \n])*$/,
    LS: /^([a-zA-Z!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~ \n])*$/,
    NS: /^([0-9!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~ \n])*$/,
    L: /^([a-zA-Z \n])*$/,
    N: /^([0-9 \n])*$/,
    S: /^([!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~ \n])*$/
  },
  timeFormat: {
    "12hr": /^(0?[1-9]|1[012]):[0-5][0-9]$/,
    "24hr": /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
  }
};

export default regExps;
